<app-action-service-container #actionServiceContainer
                              [entity]="entity"
    [actionSuccessMessage]="actionSuccessMessage"
                              [displayLoading]="false"
    [actionErrorMessage]="actionErrorMessage"
    (actionSuccessEvent)="actionSuccessEvent.emit($event)"
    (actionErrorEvent)="actionErrorEvent.emit($event)"
    [buildPayload]="buildPayload"
    [service]="service">
    <app-button (clickEvent)="executeAction()"
                *ngIf="!confirmationOptions"
                [disabled]="disabled"
                [fill]="fill"
                [iconName]="iconName"
                [label]="label"
                [loading]="service.loading$ | async"
                [tooltip]="tooltip"
                [size]="size"
                [withMargin]="withMargin"
                [withPadding]="withPadding"
                [entity]="entity"
                [hideIfNoPermission]="hideIfNoPermission"
                [color]="color"
                [permission]="permission">
    </app-button>
    <app-confirmation-button *ngIf="confirmationOptions"
                             [disabled]="disabled"
                             [fill]="fill"
                             [iconName]="iconName"
                             [tooltip]="tooltip"
                             [label]="label"
                             [size]="size"
                             [color]="color"
                             [loading]="service.loading$ | async"
                             [withMargin]="withMargin"
                             [withPadding]="withPadding"
                             (confirm)="executeAction()">
    </app-confirmation-button>
</app-action-service-container>
